import NavBar from "../components/NavBar";
import { Link } from "react-router-dom";

function QuizIntroduction() {
  return (
    <div className="min-h-screen">
      <NavBar></NavBar>
      <h1 className="text-4xl font-semibold text-gray-900 mb-3 mt-8 text-center">
        Our Yes List
      </h1>

      <h2 className="text-2xl text-gray-900 mb-3 text-center">
        Find your mutual interests
      </h2>
      <div className="mx-auto px-8 py-16 flex flex-col items-center">
        <div className="bg-gray-100 rounded-lg shadow-sm max-w-4xl bg-gray-100">
          <div className="px-8 py-12 flex flex-col items-start gap-8">
            <h3 className="text-2xl text-gray-900 font-bold mb-3 text-center mx-auto md:mx-0">
              How it works
            </h3>
            <p className="text-xl text-gray-600 mb-8">
              You and your partner(s) will each go through a list of activities
              and check the ones you're interested in or open to trying. Feel
              free to talk openly about your choices as you go — that's what
              this is all about! Or, if you prefer, you can fill out your list
              privately and pass the device to the next person.
            </p>
            <p className="text-xl text-gray-600 mb-8">
              After everyone completes their list, you'll see only the
              activities where there's mutual interest. Everything happens right
              here in your browser — we don't store any of your responses.
            </p>
            <Link
              className="w-64 mx-auto bg-green-500 text-white text-center py-4 rounded-lg text-lg font-semibold hover:bg-green-400 transition-colors"
              to="/quiz"
            >
              Start The Quiz
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}

export default QuizIntroduction;
